const config =  {
  klines(region) {
    let {singleDayLimit, min1Remainder, min1Remainder5} = config.region[region]
    return {
      'MIN1': {dateType: 'hh:mm', resolution: 1, limit: singleDayLimit, remainder: min1Remainder},
      '5-MIN1': {dateType: 'MM-dd', resolution: 1, limit: singleDayLimit * 5, period: 'MIN1', xMultiple: singleDayLimit, remainder: min1Remainder5},
      '1-MIN1': {dateType: 'MM-dd hh:mm', resolution: 1, limit: 960, period: 'MIN1'},
      'MIN5': {dateType: 'MM-dd hh:mm', resolution: 5, limit: 960},
      'MIN15': {dateType: 'MM-dd hh:mm', resolution: 15, limit: 960},
      'MIN30': {dateType: 'MM-dd hh:mm', resolution: 30, limit: 960},
      'MIN60': {dateType: 'MM-dd hh:mm', resolution: 60, limit: 960},
      'DAY': {dateType: 'yyyy-MM-dd', labelDateType: 'yyyy-MM-dd', resolution: 24 * 3600, limit: singleDayLimit * 5},
      'BS': {dateType: 'yyyy-MM', labelDateType: 'yyyy-MM-dd', resolution: 24 * 3600, limit: singleDayLimit * 5},
      'WEEK': {dateType: 'yyyy-MM', labelDateType: 'yyyy-MM-dd', resolution: 7 * 24 * 3600, limit: singleDayLimit * 5},
      'MONTH': {dateType: 'yyyy-MM', labelDateType: 'yyyy-MM-dd', resolution: 30 * 24 * 3600, limit: singleDayLimit * 5},
    }
  },
  tradingKlines: ['MIN1', '5-MIN1'],
  // 1-MIN1
  minKlines: ['MIN5', 'MIN15', 'MIN30', 'MIN60'],
  noMA: ['SH:000001', 'SZ:399001', 'SZ:399005', 'SZ:399006', 'SZ:399300'],
  region: {
    HK: {
      precision: 3,
      singleHand: 1,
      singleDayLimit: 337,
      min1Remainder: 20,
      min1Remainder5: 170
    },
    USA: {
      precision: 3,
      singleHand: 1,
      singleDayLimit: 390,
      min1Remainder: 25,
      min1Remainder5: 195
    },
    CN: {
      precision: 2,
      singleHand: 100,
      singleDayLimit: 240,
      min1Remainder: 15,
      min1Remainder5: 120
    }
  }
}

export default config
